import personalLoanCalculatorKoApi from '../../api/personal-loan-calculator-ko-api';
const PERSONAL_LOAN_CALCULATOR_KO_REQUEST = 'personalLoanCalculatorKoRequest';
const PERSONAL_LOAN_CALCULATOR_KO_FAILURE = 'personalLoanCalculatorKoFailure';
const PERSONAL_LOAN_CALCULATOR_MODAL_FIRST_STATE = 'personalLoanCalculatorModalFirstState';
const PERSONAL_LOAN_CALCULATOR_MODAL_SECOND_STATE = 'personalLoanCalculatorModalSecondState';
const PERSONAL_LOAN_CALCULATOR_KO_FORM_LOADED = 'personalLoanCalculatorKoFormLoaded';
const PERSONAL_LOAN_CALCULATOR_KO_CALC_RESPONSE = 'personalLoanCalculatorKoCalcResponse';
const PERSONAL_LOAN_CALCULATOR_KO_SET_UUID = 'PERSONAL_LOAN_CALCULATOR_KO_SET_UUID';

const personalLoanCalculatorKoState = {
	loading: false,
	technicalError: false,
	firstStep: true,
	secondStep: false,
	koFormData: [],
	koCalculationResponse: null,
	uuid: null
};

const personalLoanCalculatorKoActions = {
	calculate({ commit, state }, dataObject) {
		let calculationResult = dataObject.calculationResult;
		let formData = dataObject.formData;
		let data = { calculationResponse: calculationResult, answers: [] };
		for (let key in formData) {
			data.answers.push(formData[key]);
		}
		personalLoanCalculatorKoApi
			.calculate(Object.assign({}, data, { uuid: state.uuid }))
			.then((response) => {
				commit(PERSONAL_LOAN_CALCULATOR_KO_CALC_RESPONSE, response.data);
				commit(PERSONAL_LOAN_CALCULATOR_MODAL_SECOND_STATE);
			})
			.catch(() => {
				commit(PERSONAL_LOAN_CALCULATOR_KO_FAILURE);
			});
	},
	getKoForm({ commit }) {
		personalLoanCalculatorKoApi
			.getKoForm()
			.then((response) => {
				commit(PERSONAL_LOAN_CALCULATOR_KO_FORM_LOADED, response.data);
			})
			.catch(() => {
				commit(PERSONAL_LOAN_CALCULATOR_KO_FAILURE);
			});
	},
	resetKoForm({ commit }) {
		commit(PERSONAL_LOAN_CALCULATOR_MODAL_FIRST_STATE);
	},
	setUuid({ commit }, uuid) {
		commit(PERSONAL_LOAN_CALCULATOR_KO_SET_UUID, uuid);
	}
};

const personalLoanCalculatorKoMutations = {
	[PERSONAL_LOAN_CALCULATOR_KO_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_KO_REQUEST](state) {
		state.loading = true;
	},
	[PERSONAL_LOAN_CALCULATOR_MODAL_FIRST_STATE](state) {
		state.firstStep = true;
		state.secondStep = false;
	},
	[PERSONAL_LOAN_CALCULATOR_MODAL_SECOND_STATE](state) {
		state.firstStep = false;
		state.secondStep = true;
	},
	[PERSONAL_LOAN_CALCULATOR_KO_FORM_LOADED](state, responseData) {
		state.koFormData = responseData;
	},
	[PERSONAL_LOAN_CALCULATOR_KO_CALC_RESPONSE](state, responseData) {
		state.koCalculationResponse = responseData;
	},
	[PERSONAL_LOAN_CALCULATOR_KO_SET_UUID](state, uuid) {
		state.uuid = uuid;
	}
};

export default {
	namespaced: true,
	state: personalLoanCalculatorKoState,
	mutations: personalLoanCalculatorKoMutations,
	actions: personalLoanCalculatorKoActions
};
